import { Component, OnDestroy } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { SharedService } from '../../services/shared.service';

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss'],
    standalone: false
})

export class HeaderComponent implements OnDestroy {
    public currentDate: Date = new Date();
    public currentTime: Date = new Date();
    public currentLanguage: string = "";
    public mustShow: boolean = true;

    private intervalId: number;
    private routerSub: Subscription;
    private langSub: Subscription;

    constructor(private translate: TranslateService, private sharedService: SharedService, private router: Router) {
        this.currentLanguage = this.translate.currentLang;
        // Update mustShow only on route change
        const updateMustShow = () => {
            const url = this.router.url.toLowerCase();
            this.mustShow = !url.includes('big');
        };
        updateMustShow(); // Set initial value
        this.routerSub = this.router.events.subscribe(event => {
            if (event instanceof NavigationEnd) {
                updateMustShow();
            }
        });
        this.langSub = this.translate.onLangChange
        .subscribe((langChangeEvent: LangChangeEvent) => {
            this.currentLanguage = langChangeEvent.lang;
        });

        this.intervalId = window.setInterval(() => {
            this.updateDateTime();
        }, 1000);
    }

    ngOnDestroy(): void {
        clearInterval(this.intervalId);
        this.routerSub?.unsubscribe();
        this.langSub?.unsubscribe();
    }

    private updateDateTime(): void {
        const now = new Date();
        this.currentDate = now;
        this.currentTime = now;
    }
}